var map = {
	"./$pac.png": 92440,
	"./0xbtc.png": 85908,
	"./1inch.png": 67648,
	"./2give.png": 5636,
	"./aave.png": 72788,
	"./abt.png": 30464,
	"./act.png": 87848,
	"./actn.png": 26420,
	"./ada.png": 40264,
	"./add.png": 33652,
	"./adx.png": 89640,
	"./ae.png": 39552,
	"./aeon.png": 67988,
	"./aeur.png": 63636,
	"./agi.png": 40496,
	"./agrs.png": 12604,
	"./aion.png": 81908,
	"./algo.png": 14616,
	"./amb.png": 44724,
	"./amp.png": 75304,
	"./ampl.png": 66512,
	"./ankr.png": 31296,
	"./ant.png": 69308,
	"./ape.png": 34031,
	"./apex.png": 54212,
	"./appc.png": 73912,
	"./ardr.png": 55956,
	"./arg.png": 33028,
	"./ark.png": 60989,
	"./arkm.png": 30407,
	"./arn.png": 55252,
	"./arnx.png": 3736,
	"./ary.png": 97388,
	"./ast.png": 15064,
	"./atlas.png": 240,
	"./atm.png": 26064,
	"./atom.png": 31816,
	"./audr.png": 63804,
	"./aury.png": 63200,
	"./auto.png": 73840,
	"./avax.png": 5544,
	"./aywa.png": 34188,
	"./bab.png": 79232,
	"./bal.png": 12404,
	"./band.png": 18500,
	"./bat.png": 83168,
	"./bay.png": 59080,
	"./bcbc.png": 57788,
	"./bcc.png": 36372,
	"./bcd.png": 65980,
	"./bch.png": 65365,
	"./bcio.png": 6412,
	"./bcn.png": 28013,
	"./bco.png": 19628,
	"./bcpt.png": 18972,
	"./bdl.png": 16748,
	"./beam.png": 56552,
	"./bela.png": 94952,
	"./bix.png": 44248,
	"./blcn.png": 5668,
	"./blk.png": 74708,
	"./block.png": 66844,
	"./blz.png": 40148,
	"./bnb.png": 60812,
	"./bnt.png": 15412,
	"./bnty.png": 10792,
	"./booty.png": 16396,
	"./bos.png": 98784,
	"./bpt.png": 49716,
	"./bq.png": 36804,
	"./brd.png": 83912,
	"./bsd.png": 49868,
	"./bsv.png": 21072,
	"./btc.png": 40776,
	"./btcd.png": 58903,
	"./btch.png": 76784,
	"./btcp.png": 83847,
	"./btcz.png": 51972,
	"./btdx.png": 46780,
	"./btg.png": 87744,
	"./btm.png": 30224,
	"./bts.png": 13572,
	"./btt.png": 58176,
	"./btx.png": 37072,
	"./burst.png": 26188,
	"./bze.png": 84120,
	"./call.png": 76408,
	"./cc.png": 72484,
	"./cdn.png": 65836,
	"./cdt.png": 91259,
	"./cenz.png": 11332,
	"./chain.png": 77544,
	"./chat.png": 70500,
	"./chips.png": 7592,
	"./chsb.png": 8436,
	"./chz.png": 52876,
	"./cix.png": 65080,
	"./clam.png": 62100,
	"./cloak.png": 11984,
	"./cmm.png": 48532,
	"./cmt.png": 23557,
	"./cnd.png": 24220,
	"./cnx.png": 75040,
	"./cny.png": 22284,
	"./cob.png": 50780,
	"./colx.png": 12816,
	"./comp.png": 48932,
	"./coqui.png": 91388,
	"./cred.png": 65620,
	"./crpt.png": 83112,
	"./crv.png": 23596,
	"./crw.png": 10704,
	"./cs.png": 596,
	"./ctr.png": 35432,
	"./ctxc.png": 32492,
	"./cvc.png": 18463,
	"./d.png": 59965,
	"./dai.png": 53832,
	"./dash.png": 27756,
	"./dat.png": 75528,
	"./data.png": 10624,
	"./dbc.png": 6064,
	"./dcn.png": 58068,
	"./dcr.png": 35180,
	"./deez.png": 84031,
	"./dent.png": 38424,
	"./dew.png": 70732,
	"./dgb.png": 18280,
	"./dgd.png": 70136,
	"./dlt.png": 74620,
	"./dnt.png": 77052,
	"./dock.png": 43908,
	"./doge.png": 61356,
	"./dot.png": 43440,
	"./drgn.png": 20564,
	"./drop.png": 45596,
	"./dta.png": 77800,
	"./dth.png": 94816,
	"./dtr.png": 67625,
	"./ebst.png": 92111,
	"./eca.png": 23760,
	"./edg.png": 17256,
	"./edo.png": 60032,
	"./edoge.png": 4152,
	"./ela.png": 17836,
	"./elec.png": 84632,
	"./elf.png": 4968,
	"./elix.png": 22940,
	"./ella.png": 25008,
	"./emb.png": 97148,
	"./emc.png": 59508,
	"./emc2.png": 76520,
	"./eng.png": 580,
	"./enj.png": 82268,
	"./entrp.png": 80396,
	"./eon.png": 3676,
	"./eop.png": 72004,
	"./eos.png": 6400,
	"./eqli.png": 21000,
	"./equa.png": 25328,
	"./etc.png": 51668,
	"./eth.png": 97312,
	"./ethos.png": 86004,
	"./etn.png": 22920,
	"./etp.png": 71800,
	"./eur.png": 76136,
	"./evx.png": 26048,
	"./exmo.png": 26852,
	"./exp.png": 38448,
	"./fair.png": 40676,
	"./fct.png": 53100,
	"./fida.png": 45160,
	"./fil.png": 92936,
	"./fjc.png": 61860,
	"./fldc.png": 57316,
	"./flo.png": 35304,
	"./floki.png": 74788,
	"./flux.png": 73676,
	"./fsn.png": 3048,
	"./ftc.png": 88052,
	"./fuel.png": 9200,
	"./fun.png": 41976,
	"./game.png": 40040,
	"./gas.png": 39028,
	"./gbp.png": 6460,
	"./gbx.png": 91560,
	"./gbyte.png": 97492,
	"./generic.png": 17460,
	"./gin.png": 49860,
	"./glxt.png": 4456,
	"./gmr.png": 32848,
	"./gmt.png": 42764,
	"./gno.png": 45508,
	"./gnt.png": 68316,
	"./gold.png": 45664,
	"./grc.png": 76776,
	"./grin.png": 90980,
	"./grs.png": 70788,
	"./grt.png": 11316,
	"./gsc.png": 81164,
	"./gto.png": 49424,
	"./gup.png": 932,
	"./gusd.png": 78568,
	"./gvt.png": 52116,
	"./gxs.png": 70564,
	"./gzr.png": 77448,
	"./hight.png": 5480,
	"./hns.png": 1424,
	"./hodl.png": 82820,
	"./hot.png": 51240,
	"./hpb.png": 57524,
	"./hsr.png": 16864,
	"./ht.png": 57076,
	"./html.png": 30412,
	"./huc.png": 72292,
	"./husd.png": 19448,
	"./hush.png": 57200,
	"./icn.png": 14348,
	"./icp.png": 84344,
	"./icx.png": 61100,
	"./ignis.png": 43696,
	"./ilk.png": 78612,
	"./ink.png": 50428,
	"./ins.png": 24524,
	"./ion.png": 75204,
	"./iop.png": 47068,
	"./iost.png": 86088,
	"./iotx.png": 95516,
	"./iq.png": 19436,
	"./itc.png": 24268,
	"./jnt.png": 87264,
	"./jpy.png": 13984,
	"./kcs.png": 92420,
	"./kin.png": 54148,
	"./klown.png": 81956,
	"./kmd.png": 59504,
	"./knc.png": 66688,
	"./krb.png": 1776,
	"./ksm.png": 60956,
	"./lbc.png": 36308,
	"./lend.png": 86100,
	"./leo.png": 824,
	"./link.png": 25532,
	"./lkk.png": 82824,
	"./loom.png": 2068,
	"./lpt.png": 11148,
	"./lrc.png": 62251,
	"./lsk.png": 98716,
	"./ltc.png": 66757,
	"./lun.png": 89509,
	"./maid.png": 45904,
	"./mana.png": 57476,
	"./matic.png": 23708,
	"./max.png": 74304,
	"./mcap.png": 93128,
	"./mco.png": 72447,
	"./mda.png": 29232,
	"./mds.png": 94201,
	"./med.png": 87044,
	"./meetone.png": 64596,
	"./mft.png": 41644,
	"./miota.png": 11812,
	"./mith.png": 11876,
	"./mkr.png": 65036,
	"./mln.png": 37725,
	"./mnx.png": 37112,
	"./mnz.png": 66663,
	"./moac.png": 17599,
	"./mod.png": 8516,
	"./mona.png": 74432,
	"./msr.png": 84620,
	"./mth.png": 99620,
	"./mtl.png": 38916,
	"./music.png": 83604,
	"./mzc.png": 36284,
	"./nano.png": 53568,
	"./nas.png": 43208,
	"./nav.png": 33157,
	"./ncash.png": 51692,
	"./ndz.png": 15076,
	"./nebl.png": 31912,
	"./neo.png": 16532,
	"./neos.png": 86964,
	"./neu.png": 37972,
	"./nexo.png": 53240,
	"./ngc.png": 3740,
	"./nio.png": 22336,
	"./nkn.png": 79548,
	"./nlc2.png": 56564,
	"./nlg.png": 14384,
	"./nmc.png": 71200,
	"./nmr.png": 83348,
	"./npxs.png": 57540,
	"./ntbc.png": 20632,
	"./nuls.png": 98244,
	"./nxs.png": 92288,
	"./nxt.png": 46444,
	"./oax.png": 20556,
	"./ok.png": 55136,
	"./omg.png": 25199,
	"./omni.png": 90132,
	"./one.png": 12804,
	"./ong.png": 22684,
	"./ont.png": 26288,
	"./oot.png": 58268,
	"./ost.png": 45976,
	"./ox.png": 12480,
	"./oxt.png": 49984,
	"./oxy.png": 31320,
	"./part.png": 13207,
	"./pasc.png": 61464,
	"./pasl.png": 23044,
	"./pax.png": 9956,
	"./paxg.png": 22520,
	"./pay.png": 22376,
	"./payx.png": 66556,
	"./pepe.png": 34164,
	"./pink.png": 40524,
	"./pirl.png": 62480,
	"./pivx.png": 22692,
	"./plr.png": 6128,
	"./poa.png": 92108,
	"./poe.png": 30764,
	"./polis.png": 67304,
	"./poly.png": 11248,
	"./pot.png": 2608,
	"./powr.png": 18256,
	"./ppc.png": 88848,
	"./ppp.png": 60984,
	"./ppt.png": 10436,
	"./pre.png": 51320,
	"./prl.png": 39972,
	"./pungo.png": 61268,
	"./pura.png": 87428,
	"./qash.png": 880,
	"./qiwi.png": 64836,
	"./qlc.png": 57984,
	"./qnt.png": 80267,
	"./qrl.png": 37680,
	"./qsp.png": 77613,
	"./qtum.png": 84560,
	"./r.png": 5500,
	"./rads.png": 56868,
	"./rap.png": 43796,
	"./ray.png": 67128,
	"./rcn.png": 97648,
	"./rdd.png": 57556,
	"./rdn.png": 13468,
	"./ren.png": 37256,
	"./rep.png": 8100,
	"./repv2.png": 34828,
	"./req.png": 29720,
	"./rhoc.png": 86136,
	"./ric.png": 67756,
	"./rise.png": 25444,
	"./rlc.png": 89495,
	"./rpx.png": 10668,
	"./rub.png": 42976,
	"./rvn.png": 54308,
	"./ryo.png": 6172,
	"./safe.png": 14265,
	"./safemoon.png": 94852,
	"./sai.png": 9668,
	"./salt.png": 3040,
	"./san.png": 34724,
	"./sand.png": 61780,
	"./sbd.png": 30804,
	"./sberbank.png": 97616,
	"./sc.png": 6612,
	"./ser.png": 33061,
	"./shift.png": 91652,
	"./sib.png": 396,
	"./sin.png": 29244,
	"./skl.png": 76484,
	"./sky.png": 80324,
	"./slr.png": 28836,
	"./sls.png": 93640,
	"./smart.png": 75008,
	"./sngls.png": 71604,
	"./snm.png": 62324,
	"./snt.png": 40976,
	"./snx.png": 12560,
	"./soc.png": 68444,
	"./sol.png": 49496,
	"./spacehbit.png": 26452,
	"./spank.png": 67592,
	"./sphtx.png": 50572,
	"./srn.png": 24208,
	"./stak.png": 67284,
	"./start.png": 19500,
	"./steem.png": 67100,
	"./storj.png": 69180,
	"./storm.png": 18560,
	"./stox.png": 35576,
	"./stq.png": 92132,
	"./strat.png": 54692,
	"./stx.png": 34872,
	"./sub.png": 96548,
	"./sumo.png": 6668,
	"./sushi.png": 53148,
	"./sys.png": 67624,
	"./taas.png": 76052,
	"./tau.png": 22748,
	"./tbx.png": 2872,
	"./tel.png": 9596,
	"./ten.png": 39252,
	"./tern.png": 39084,
	"./tgch.png": 94591,
	"./theta.png": 3807,
	"./tix.png": 99052,
	"./tkn.png": 76067,
	"./tks.png": 80932,
	"./tnb.png": 28800,
	"./tnc.png": 79616,
	"./tnt.png": 12292,
	"./tomo.png": 66024,
	"./tpay.png": 13804,
	"./trig.png": 34052,
	"./trtl.png": 64892,
	"./trx.png": 12500,
	"./tusd.png": 20196,
	"./tzc.png": 12184,
	"./ubq.png": 58988,
	"./uma.png": 58004,
	"./uni.png": 34672,
	"./unity.png": 13148,
	"./usd.png": 94564,
	"./usdc.png": 67292,
	"./usdt.png": 34900,
	"./utk.png": 36960,
	"./veri.png": 96072,
	"./vet.png": 93008,
	"./via.png": 14124,
	"./vib.png": 66848,
	"./vibe.png": 23608,
	"./vivo.png": 48872,
	"./vrc.png": 70608,
	"./vrsc.png": 54612,
	"./vtc.png": 98276,
	"./vtho.png": 35776,
	"./wabi.png": 76360,
	"./wan.png": 72084,
	"./waves.png": 20368,
	"./wax.png": 39172,
	"./wbtc.png": 85044,
	"./wgr.png": 76124,
	"./wicc.png": 23700,
	"./wings.png": 72240,
	"./wpr.png": 46451,
	"./wtc.png": 51060,
	"./x.png": 8212,
	"./xas.png": 52732,
	"./xbc.png": 59280,
	"./xbp.png": 16064,
	"./xby.png": 84180,
	"./xcp.png": 96280,
	"./xdn.png": 23589,
	"./xem.png": 12640,
	"./xin.png": 30275,
	"./xlm.png": 8837,
	"./xmcc.png": 34548,
	"./xmg.png": 86852,
	"./xmo.png": 66444,
	"./xmr.png": 56488,
	"./xmy.png": 22000,
	"./xp.png": 91968,
	"./xpa.png": 37468,
	"./xpm.png": 73880,
	"./xpr.png": 80308,
	"./xrp.png": 75208,
	"./xsg.png": 14588,
	"./xtz.png": 11792,
	"./xuc.png": 28692,
	"./xvc.png": 91704,
	"./xvg.png": 35856,
	"./xzc.png": 94664,
	"./yfi.png": 4176,
	"./yoyow.png": 384,
	"./zcl.png": 74864,
	"./zec.png": 97049,
	"./zel.png": 36500,
	"./zen.png": 67020,
	"./zest.png": 75668,
	"./zil.png": 78452,
	"./zilla.png": 69500,
	"./zrx.png": 79356
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54512;